export enum FileType {
    csv = 1,
    xlsx = 2,
    xml = 3,
    json = 4,
}
